import { hasCode } from '../../schema/widgets/ICodeWidget.ts';
import {
  type IParentWidgetScope,
  type IParentWidgetScopeItem,
} from '../../schema/widgets/IWidgetType.ts';
import { type Widget } from '../../schema/widgets/Widget.ts';

/**
 * La funzione permette di estrarre da un widget tutte le informazioni
 * utili per la validazione dei suoi figli.
 * Un esempio sono la visibilità e la disabilitazione, che devono essere
 * passati "sotto".
 *
 * e.g.: se una Row è disabilitata, anche i suoi figli devono essere disabilitati.
 */
export function getParentValidationScope(
  widget: Widget,
  actualScope: IParentWidgetScope = [],
  extra: Partial<IParentWidgetScopeItem> = {},
): IParentWidgetScope {
  const newScope = [
    ...actualScope,
    {
      visible: widget.visible,
      enabled: widget.enabled,
      code: hasCode(widget) ? widget.code : undefined,
      ...extra,
    },
  ];
  return newScope;
}
